import api from "../../../api";

export async function createAssignment(payload) {
  const response =
    await api.post("/assignments", payload);

  return response.data?.assignment || null;
}

export async function listLaunchableEvaluationTasks() {
  const response =
    await api.get("/assignments/evaluation-tasks");

  return response.data?.evaluationTasks || [];
}

export async function inspectAssignmentActivity(activityId, assignmentId) {
  const path = `/assignments/evaluation-tasks/${activityId}`;
  const response = assignmentId
    ? await api.get(path, { params: { assignmentId } })
    : await api.get(path);
  return response.data?.activity || null;
}

export async function issueAssignmentInspectionMediaDescriptor({ assignmentId, activityId, stimulusInstanceId }) {
  const response = await api.post(`/assignments/owned/${assignmentId}/activity-media-descriptor`, {
    consumerContext: "ASSIGNMENT_ACTIVITY_INSPECTION",
    activityId,
    stimulusInstanceId,
  });
  return response.data?.descriptor || null;
}

export async function getAssignmentCompositionActions() {
  const response = await api.get("/assignments/composition-actions");
  return response.data?.validActions || {
    chooseActivity: false,
    createActivity: false,
  };
}

export async function listOwnedAssignments() {
  const response =
    await api.get("/assignments/owned");

  return response.data?.assignments || [];
}

export async function getOwnedAssignment(assignmentId) {
  const response =
    await api.get(`/assignments/owned/${assignmentId}`);

  return response.data || null;
}

export async function updateDraftAssignment(assignmentId, payload) {
  const response =
    await api.patch(`/assignments/owned/${assignmentId}`, payload);

  return response.data?.assignment || null;
}

export async function publishAssignment(assignmentId) {
  const response =
    await api.post(`/assignments/owned/${assignmentId}/publish`);

  return response.data?.assignment || null;
}

export async function closeAssignment(assignmentId, payload = {}) {
  const response =
    await api.post(`/assignments/owned/${assignmentId}/close`, payload);

  return response.data?.assignment || null;
}

export async function archiveAssignment(assignmentId) {
  const response =
    await api.post(`/assignments/owned/${assignmentId}/archive`);

  return response.data?.assignment || null;
}

export async function cancelAssignment(assignmentId, payload = {}) {
  const response =
    await api.post(`/assignments/owned/${assignmentId}/cancel`, payload);

  return response.data?.assignment || null;
}

export async function getAssignmentMonitoring(assignmentId) {
  const response =
    await api.get(`/assignments/owned/${assignmentId}/monitoring`);

  return response.data || null;
}

export async function listAssignedAssignments() {
  const response =
    await api.get("/assignments/assigned");

  return response.data?.assignments || [];
}

export async function getAssignedAssignment(assignmentId) {
  const response =
    await api.get(`/assignments/assigned/${assignmentId}`);

  return response.data || null;
}

export async function startOrResumeAssignment(assignmentId) {
  const response =
    await api.post(`/assignments/assigned/${assignmentId}/start-or-resume`);

  return response.data || null;
}

export async function completeAssignmentAttempt(assignmentId) {
  const response =
    await api.post(`/assignments/assigned/${assignmentId}/attempt/complete`);

  return response.data || null;
}
